<template>
	<c-dialog ref="dialog" :title="stationed_type == 1? '商家库':'经销商库'" width="900" @resolve="resolve">
		<m-search ref="search" @search="search">
			<c-form ref="form" inline>
				<c-form-item type="input" label="商家名称" name="company_name"></c-form-item>
				<c-form-item type="input" label="店铺名称" name="shop_name"></c-form-item>
			</c-form>
		</m-search>
			
		<c-table ref="table" height="400">
			<c-table-column
				type="selector"
        :multiple="!!multiple"
			></c-table-column>

			<c-table-column 
				label="状态" 
				name="state"  
				width="60">
				<template v-slot="{data}">
				  <span v-if="data.state == 1" style="color:red">停用</span>
				  <span v-if="data.state == 2" style="color:green">启用</span>
				</template>
			</c-table-column>

			<c-table-column
				label="商家名称"
				name="company_name"
				width="150"
			>
			</c-table-column>


			<c-table-column
				label="店铺名称"
				name="shop_name"
				width="150"
			>
				<template v-slot="{data}">
					<span v-if="data.shop_name && data.shop_name!=''">{{data.shop_name}}</span>
					<span v-else>--</span>
				</template>
			</c-table-column>

			<c-table-column
				label="运营模式"
				name="operation_mode"
				width="80"
				v-if="systemConfig.pt_mode == 2 && systemConfig.operation_mode_enabled == 'ON' && this.stationed_type == 1" 
			>
				<template v-slot="{data}">
				  <span v-if="data.operation_mode == 1">平台自营</span>
				   <span v-if="data.operation_mode == 2">商家自营</span>
				</template>
			</c-table-column>

			<c-table-column
				label="商家类型"
				name="auth_name"
				width="100"
			>
			</c-table-column>
		</c-table>
	</c-dialog>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
		data() {
			return {
				stationed_type: 1
			}
		},
		props: {
			multiple: Boolean
		},
		
		computed: {
			...mapState(['systemConfig'])
		},
		methods: {
			search(data) {
				data.stationed_type = this.stationed_type;
				this.$refs.table.load({
					url: '/stationed/list',
					data
				});
			},
			
			//商家类型（1：商家，2：经销商）
			open(sta_type) {
				this.stationed_type = sta_type||1;
				this.$refs.form.clear();
				this.$nextTick(() => {
					this.$refs.search.search();
				})
				this.$refs.dialog.open();
			},
			
			resolve(stop) {
				var data = this.$refs.table.getRow('selected');
				if (!data.length) {
					stop();
					this.$message({
						text: '请选择商家'
					});
					return;
				}
				this.$emit('resolve', Array.from(data, item => item.data));
			}
		}
	}
</script>